import { clearUser } from "../analytics";
import { readCache } from "./readCache";
export function clearSession() {
  clearUser();
  ["userToken", "refreshToken", "hasLoggedIn", "profile", "profiles", "userInfo", "sessionid", "interfaceurl"].forEach(key => localStorage.removeItem(key));
  sessionStorage.removeItem("pin");
  Object.keys(sessionStorage).filter(key => key.startsWith("notification-preferences:")).forEach(key => sessionStorage.removeItem(key));
  readCache.clear();
}
